<template>
  <high-org-chart ref="chart"></high-org-chart>
</template>

<script>
import HighOrgChart from "@/views/Tools/SecPeak/Components/HighOrgChart";

export default {
  name: "PitstopPeopleA",
  components: {
    HighOrgChart,
  },
  methods: {
    reset() {
      if(this.$refs['chart']) {
        this.$refs.chart.reset()
      }
    },
  },
}
</script>

<style scoped>

</style>